// extracted by mini-css-extract-plugin
export default {"card":"TeamCard_card__zlIUd","profile":"TeamCard_profile__PthSp","content":"TeamCard_content__wHOny","name":"TeamCard_name__EUn6k","socials":"TeamCard_socials__9Vkdk"};